var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignments = function SvgAlignments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.163 17H14.836M12.5 3V4M18.864 5.636L18.157 6.343M21.5 12H20.5M4.5 12H3.5M6.843 6.343L6.136 5.636M8.964 15.536C8.26487 14.8367 7.7888 13.9458 7.59598 12.9759C7.40316 12.006 7.50225 11.0008 7.88073 10.0872C8.25921 9.17366 8.90007 8.39284 9.72229 7.84349C10.5445 7.29414 11.5111 7.00093 12.5 7.00093C13.4889 7.00093 14.4555 7.29414 15.2777 7.84349C16.0999 8.39284 16.7408 9.17366 17.1193 10.0872C17.4977 11.0008 17.5968 12.006 17.404 12.9759C17.2112 13.9458 16.7351 14.8367 16.036 15.536L15.488 16.083C15.1747 16.3963 14.9262 16.7683 14.7567 17.1777C14.5872 17.5871 14.4999 18.0259 14.5 18.469V19C14.5 19.5304 14.2893 20.0391 13.9142 20.4142C13.5391 20.7893 13.0304 21 12.5 21C11.9696 21 11.4609 20.7893 11.0858 20.4142C10.7107 20.0391 10.5 19.5304 10.5 19V18.469C10.5 17.574 10.144 16.715 9.512 16.083L8.964 15.536Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAlignments;